import {
	isTouchDevice
} from './modules/dpitUtilsPublic';

jQuery(document).ready(($) => {
	if (window.dpIntroTourCreateNewConfig.dpDebugEn) console.log('[dpit] INIT dpit-admin-bar');

	if (window.dpIntroTourCreateNewConfig.adminColors) {
		// Conditional loading
		import(/* webpackChunkName: "AdminThemeColors" */ '../../../includes/assets/js/modules/AdminThemeColors')
			.then((script) => new script.default(window.dpIntroTourCreateNewConfig));
	}

	$('.dpit-ab-li>a').on('click', event => {
		if (isTouchDevice()) {
			event.preventDefault();
			return false;
		}
	});


	$('#wp-admin-bar-create-new-tour a, #wp-admin-bar-new-dp_intro_tours a').on('click', (event) => {
		event.preventDefault();
		const tourName = prompt(window.dpIntroTourCreateNewConfig.i18n.setNewTourNamePrompt, window.dpIntroTourCreateNewConfig.defaultTourName);
		if (tourName) {
			const href = $(event.target).closest('a').attr('href');
			if (href) {
				window.location = `${href}&${window.dpIntroTourCreateNewConfig.tourNameQParamName}=${tourName}`;
			}
		}
	});
});